module.exports = __webpack_public_path__ + "static/media/covered_right_image.ae66d3db.svg";